<template lang="pug">
  v-list
    // 多層
    v-list-group(
      v-for="item in menuItems"
      :value="getActiveStatus(item)"
      :key="item.title"
      v-if="item.subMenuItems")
      // 第一層
      v-list-tile(slot="activator")
        v-list-tile-action.pl-2
          v-icon {{ item.action }}
        v-list-tile-content
          v-list-tile-title {{ item.title }}
      // 第二層
      v-list-tile(:to="subItem.path" v-for="subItem in item.subMenuItems" :key="subItem.title" active-class="achYellow--text")
        v-list-tile-action
          v-icon {{ subItem.action }}
        v-list-tile-content
          v-list-tile-title {{ subItem.title }}
    // 單一層
    v-list-tile(:to="item.path" :value="getActiveStatus(item)" active-class="achYellow--text" v-else)
      v-list-tile-action.pl-2
        v-badge(overlap right color="achRed" :value="item.newStatus === true")
          v-icon(slot="badge" dark) notifications
          v-icon {{ item.action }}
      v-list-tile-content
        v-list-tile-title {{ item.title }}
</template>

<script>
export default {
  data () {
    return {}
  },
  mounted () {
  },
  computed: {
    menuItems () {
      return [
        {
          action: 'home',
          title: '總覽',
          path: '/index'
        },
        {
          action: 'equalizer',
          title: '交易明細',
          path: '/reports/sales'
        },
        {
          action: 'attach_money',
          title: '帳務明細',
          path: '/reports/billing'
        },
        {
          action: 'notifications_none',
          title: '訊息通知',
          path: '/notifications',
          newStatus: this.getNotificationAmt !== 0
        },
        {
          action: 'account_circle',
          title: '帳號資訊',
          path: '/stores'
        }
        // {
        //   action: 'settings',
        //   title: '設定',
        //   subMenuItems: [
        //     {
        //       title: '一般設定',
        //       path: '/settings'
        //     }
        //   ]
        // }
      ]
    },
    getNotificationAmt () {
      return this.$store.getters.getNotifications.filter(item => item.read === false).length
    }
  },
  methods: {
    getActiveStatus (item) {
      let path = this.$route.path
      return (item.path)
        ? item.path === path
        : item.subMenuItems.find(secondItem => {
          return secondItem.path === path
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
